import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ChartModel } from 'src/app/models/chart.model';
import { User } from 'src/app/models/user.model';
import { ClickStreamService } from 'src/app/services/click-stream.service';
import { UserService } from 'src/app/services/user.service';
import { SelectGroupDialogComponent } from '../select-group-dialog/select-group-dialog.component';
import { ViewReportsAsDialogComponent } from '../view-reports-as-dialog/view-reports-as-dialog.component';

@Component({
  selector: 'app-admin-profile-card',
  templateUrl: './admin-profile-card.component.html',
  styleUrls: ['./admin-profile-card.component.scss']
})
export class AdminProfileCardComponent implements OnInit {
  userInitials: string;

  user: User;
  @Input('pushedCharts') pushedCharts: ChartModel[];

  constructor(private userService: UserService, public dialog: MatDialog, private router: Router, private clickstream: ClickStreamService) { }

  ngOnInit() {
    this.user = this.userService.getUser();
    this.userInitials = this.user.name.split(" ").map((n) => n[0]).join("");
    this.preloadImages(
      "../../../assets/buttons/Manage-Reports.png",
      "../../../assets/buttons/View-Reports-of.png",
      "../../../assets/buttons/Push-Charts-to-Users.png",
      "../../../assets/buttons/View-Charts-of.png")
  }

  imgs = new Array();
  imagesLoaded = false;
  preloadImages(...args: any[]): void {
    for (var i = 0; i < args.length; i++) {
      this.imgs[i] = new Image();
      this.imgs[i].src = args[i];
    }
    this.imagesLoaded = true;
  }

  openViewAsDialog() {
    this.dialog.open(SelectGroupDialogComponent);
    this.clickstream.send('view-dashboard-as-button', 'click', 'Admin Dashboard', 'View Dashbaord As Button', '', true);
  }

  clickPushButton() {
    this.clickstream.send('push-chart-button', 'click', 'Admin Dashboard', 'Push ChartModel Button', '', true);
  }

  openViewReportsOfDialog() {
    this.dialog.open(ViewReportsAsDialogComponent);
  }
}
